import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    Label,
    Card,
    CardBody
} from 'reactstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';

export default function TicketThread({
    saveIntegration,
    channelDetails
}) {
    const [channelData, setChannelData] = useState({
        isTicketCopy: false,
        replyEmail: ""
    })
    useEffect(() => {
        if (channelDetails !== null) {
            setChannelData({
                ...channelData,
                isTicketCopy: channelDetails.isTicketCopy,
                replyEmail: channelDetails.replyEmail
            })
        }
    }, [channelDetails]);
    const handleCopy = (e) => {
        var details = { ...channelDetails };
        details.isTicketCopy = e;
        setChannelData({ ...channelData, isTicketCopy: e });
        saveIntegration({ channelDetails: details });
    };
    const handleSave = () => {
        var details = { ...channelDetails };
        details.replyEmail = channelData.replyEmail;
        saveIntegration({ channelDetails: details });
    };
    return (<Fragment>
        <Card className="mb-4">
            <CardBody>
                <div className="text-center mb-2">
                    <h6>Ticket Responses</h6>
                    <span>View tickets and the corresponding email thread in Unified Inbox</span>
                </div>
                <Separator className="mb-3" />
                <div className="row mt-1 ml-2 mb-1">
                    <p className='mr-4'>Enable this feature to copy your unique ticketing email address in every ticket response. This will help you see the complete conversation thread in your Unified Inbox.</p>
                    <div className="d-flex w-100 mt-2">
                        <h5 style={{ marginTop: '0.15rem' }}>Enable Ticket Copy</h5>
                        {/* <Switch
                            className="custom-switch custom-switch-primary custom-switch-small ml-2"
                            checked={channelData.isTicketCopy}
                            name='enabled'
                            onChange={(e) => handleCopy(e)}
                        /> */}
                        <Switch
                            className="agentswitch custom-switch-primary custom-switch-small ml-3 d-sm-inline-block"
                            checked={channelData.isTicketCopy}
                            name='enabled'
                            onChange={(e) => handleCopy(e)}
                        />
                    </div>
                    <p className='mr-4 mt-2'>Your unique email address is below. You do not need to do any thing, we will send a response to this email every time you respond to a ticket generated through Myma.ai.</p>
                    <div className='row w-100 mt-2'>
                        <Colxx md={8}>
                            <Input
                                type="text"
                                value={channelData.replyEmail}
                                name="text"
                                onChange={(e) => setChannelData({ ...channelData, replyEmail: e.target.value })}
                            />
                        </Colxx>
                        <Colxx md={4}>
                            <CopyToClipboard
                                text={channelData.replyEmail}
                            >
                                <Button
                                    size="xs"
                                    outline
                                    className="ml-3 mt-1">
                                    <FontAwesomeIcon icon={faCopy} className="fa" /> Copy
                                </Button>
                            </CopyToClipboard>
                        </Colxx>
                    </div>
                </div>
                <div className="text-center">
                    <Button
                        size="xs"
                        color="primary"

                        style={{ marginTop: '20px', display: 'inline-block' }}
                        onClick={() => handleSave()}
                    >
                        Save
                    </Button>
                </div>
            </CardBody>
        </Card>
    </Fragment>)
}  